import { facts } from "../../data/facts";

function FactsList() {
  return (
    <div className="facts">
      {facts.map((fact) => (
        <div className="fact" key={fact.key}>
          <span className="k">{fact.key}</span>
          <span>{fact.value}</span>
        </div>
      ))}
    </div>
  );
}

export default FactsList;
